export default "__VITE_ASSET__11d90103__"